// extracted by mini-css-extract-plugin
module.exports = {"body":"NotFound_body__34KWn","imgContainer":"NotFound_imgContainer__10rvP","textContainer":"NotFound_textContainer__2W2K5","buttonWrapper":"NotFound_buttonWrapper__imLXj"};